<template>
  <div class="px-6">
    <vs-tabs>
      <vs-tab label="Demandes" class="py-4">
        <div class="vx-row">
          <div class="vx-col w-full md:w-3/4 mb-base">
            <vue-apex-charts v-if="!loading"
              type="area"
              height="360"
              :options="requestsSummaryCharts.options"
              :series="requestsSummaryCharts.series"/>
          </div>
          <div
            class="border border-b-0 border-r-0 border-solid border-t-0 d-theme-border-grey-light flex flex-col justify-between mb-base md:w-1/4 vx-col w-full">
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Toutes mes demandes</p>

              <p class="text-3xl">{{request_counts.total_my_request}}</p>
            </div>
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Demandes clôturées</p>
              <p class="text-3xl">{{request_counts.total_closed_request}}</p>
            </div>
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Demandes rejetées</p>
              <p class="text-3xl">{{request_counts.total_rejected_request}}</p>
            </div>
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Demandes en traitement</p>
              <p class="text-3xl">{{request_counts.total_on_treat}}</p>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts';

  export default {
    components: {VueApexCharts},
    data() {
      return {
        loading: false,
        requestsSummaryCharts: {
          options: {
            title: {
              text: 'Demandes des 6 derniers mois',
              align: 'left'
            },
            stroke: {
              curve: 'straight'
            },
            colors: ['#008ffa', '#067A2F', '#ff0003'],
            xaxis: {
              categories: [],
            },
          },
          series: []
        },
        request_counts: {
          total_my_request: 0,
          total_closed_request: 0,
          total_rejected_request: 0,
          total_on_treat: 0
        }
      }
    },
    methods: {
      requestCounts(){
        this.$vs.loading()
        this.$http.get('statistics/customer').then((response) => {
          this.request_counts = response.data
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      requestStats(){
        this.loading = true;
        this.$vs.loading()
        this.$http.post('statistics/customer/request/global/stats').then((response) => {
          const datas = response.data;
          datas.stats.forEach((data) => {
              this.requestsSummaryCharts.series.push({
                name: data.name,
                data: data.data
              })

          })
          this.requestsSummaryCharts.options.xaxis.categories = datas.months
          this.loading = false
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          this.loading = false;
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      }
    },
    mounted() {
      this.requestCounts();
      this.requestStats();
    }
  }
</script>
